import i18n, { InitOptions } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { requireResourceFiles, ResourceFile } from './requireResourceFiles'

function addResourceFiles(resourceFiles: ResourceFile[]) {
  resourceFiles.forEach(({ ns, lng, content }) =>
    i18n.addResourceBundle(lng, ns, content)
  )
}

export function initializeI18n({
  debug,
  resourceFileContext,
  resourceFiles,
  ...rest
}: Partial<InitOptions> & {
  resourceFiles?: ResourceFile[]
  resourceFileContext?: __WebpackModuleApi.RequireContext
} = {}) {
  return i18n
    .use(LanguageDetector)
    .use(initReactI18next as any)
    .init(
      {
        ...rest,
        resources: { de: {}, en: {} }, // disables autoload via backend
        fallbackLng: 'de',

        defaultNS: 'common',
        fallbackNS: ['common'],

        // keySeparator: false,

        interpolation: {
          escapeValue: false,
        },
        detection: {
          order: ['localStorage', 'navigator'],
          lookupLocalStorage: '@emos/settings/lng',
          caches: ['localStorage'],
        },
        debug:
          typeof debug === 'undefined'
            ? process.env.NODE_ENV !== 'production'
            : !!debug,
      },
      () => {
        if (resourceFileContext) {
          addResourceFiles(requireResourceFiles(resourceFileContext))
        }
        if (resourceFiles) {
          addResourceFiles(resourceFiles)
        }
      }
    )
}
